import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { ADVISORY_ROUTE_NAMES } from "meetings/advisory/routes/routeNames";

/**
 * Meeting route fragment for /my-students/transition-meetings
 * Import and spread into myStudentsRoutes.js children array.
 */
export const myStudentsTransitionMeetingFragment: AppRouteRecordRaw[] = [
  {
    path: "transition-meetings",
    name: ADVISORY_ROUTE_NAMES.MY_STUDENTS,
    component: () =>
      import(
        "meetings/advisory/pages/teacher/MyStudentsTransitionMeetingPage.vue"
      ),
    meta: {
      title: "Adviesbespreking",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [
        MODULE_SETTINGS.TRANSITION_MEETING,
        MODULE_SETTINGS.STUDENT_MEETING,
      ],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      hideTitle: true,
    },
  },
];
